import { render, staticRenderFns } from "./contentSegment.vue?vue&type=template&id=98e7eb4c"
import script from "./contentSegment.vue?vue&type=script&lang=js"
export * from "./contentSegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports